export default "__VITE_ASSET__dcb55f6b__"